import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH} from "../Config/Config";

const getUserDetails = () => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  return JSON.parse(userDetails);
};




const removeNLPAction = async({tsid}) => {
    const user = getUserDetails();

    const response = await axios.get(`${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=removeNlpAction&companyid=${user.companyid}&tsid=${tsid}`);


    return response.data;
}


const useRemoveNLPAction = (options = {}) => {
  return useMutation({
    mutationFn: removeNLPAction,
    ...options,
  });
}; 

export default useRemoveNLPAction;


